export default __webpack_public_path__ + "static/media/c.c5a24e9a.svg";